// extracted by mini-css-extract-plugin
export var boxItems = "_79-1";
export var boxItemsLg = "_79-2";
export var button = "_79-7";
export var buttonHoverless = "_79-9";
export var buttonLg = "_79-8";
export var filterGroupBox = "_79-0";
export var icon = "_79-3";
export var iconSecondary = "_79-6";
export var iconWrapper = "_79-4";
export var iconWrapperLg = "_79-5";
export var truncatedLabel = "_79-a";